module.exports = __webpack_public_path__ + "img/645.617621c5.png";